import {
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import PaperComponent from "./Paper";
import { WEB_COLORS } from "@/lib/constants";
import { Close, Edit } from "@mui/icons-material";
import { useTranslations } from "next-intl";

function RadioListCard({
  name,
  value,
  handleEdit,
  radiolabel,
  openMapDrawer,
  radioListStyle,
  menuItems = [],
  setAddressValue,
  ...props
}) {
  const setValue = (e) => {
    setAddressValue(e.target.value);
  };
  const t = useTranslations("PersonalDetails.address");

  const userProvidedAddress = menuItems?.find(
    (item) => item?.source === "USER_PROVIDED"
  );
  return (
    <>
      <FormControl fullWidth>
        {radiolabel && (
          <FormLabel id="demo-radio-buttons-group-label">
            {radiolabel}
          </FormLabel>
        )}

        <RadioGroup
          onChange={setValue}
          aria-labelledby="address-radio-buttons-group-label"
          defaultValue=""
          name={name}
          value={value}
          {...props}
        >
          {menuItems?.map((item, i) => (
            <PaperComponent
              key={item?.addressId}
              paperStyle={{
                pr: 0,
                border:
                  value === item?.addressId
                    ? `1px solid ${WEB_COLORS.primary}`
                    : "1px solid white",
                "&:hover": {
                  border: `1px solid ${WEB_COLORS.primary}`,
                },
              }}
            >
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <FormControlLabel
                  value={item?.addressId}
                  control={<Radio />}
                  label={
                    <span
                      style={{ width: "100%", textTransform: "capitalize" }}
                    >
                      <strong style={{ textTransform: "capitalize" }}>
                        {t("selectedaddress", {
                          addressType: t(`${item?.addressType?.toLowerCase()}`),
                        })}
                      </strong>
                      {t(item?.source.toLowerCase())}
                      <Typography flexWrap={"wrap"} variant="body2">
                        {item?.line1}
                      </Typography>
                      <Typography flexWrap={"wrap"} variant="body2">
                        {item?.line2}
                      </Typography>
                      <Typography flexWrap={"wrap"} variant="body2">
                        {item?.city}, {item?.state}, {item?.pin}
                      </Typography>
                    </span>
                  }
                  sx={radioListStyle}
                />
                {item.source === "USER_PROVIDED" ? (
                  <IconButton onClick={() => handleEdit(!openMapDrawer)}>
                    {openMapDrawer ? <Close /> : <Edit />}
                  </IconButton>
                ) : (
                  <></>
                )}
              </Stack>
            </PaperComponent>
          ))}
          {menuItems?.length < 3 && !userProvidedAddress && (
            <>
              <PaperComponent
                paperStyle={{
                  border: "1px solid white",
                  "&:hover": {
                    border: `1px solid ${WEB_COLORS.primary}`,
                  },
                }}
              >
                <FormControlLabel
                  value={"add"}
                  control={<Radio />}
                  label={
                    menuItems?.length === 0
                      ? t("newaddress")
                      : menuItems?.length > 1 && menuItems?.length < 3
                      ? t("differentaddress")
                      : t("differentaddress")
                  }
                  sx={radioListStyle}
                />
              </PaperComponent>
            </>
          )}
        </RadioGroup>
      </FormControl>
    </>
  );
}

export default RadioListCard;
